import { Routes } from '@angular/router';
import { authGuard, guestGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  {
    path: 'login',
    canActivate: [guestGuard],
    loadComponent: () => import('./features/auth/login/login').then(m => m.Login)
  },
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () => import('./features/layout/layout').then(m => m.Layout),
    children: [
      { path: 'dashboard',    loadComponent: () => import('./features/dashboard/dashboard').then(m => m.Dashboard) },
      { path: 'departments',  loadComponent: () => import('./features/departments/departments').then(m => m.Departments) },
      { path: 'roles',        loadComponent: () => import('./features/roles/roles').then(m => m.Roles) },
      { path: 'users',        loadComponent: () => import('./features/users/users').then(m => m.Users) },
      { path: 'modules',      loadComponent: () => import('./features/modules/modules').then(m => m.Modules) },
      { path: 'features',     loadComponent: () => import('./features/permissions/permissions').then(m => m.Permissions) },
      { path: 'permission-management', loadComponent: () => import('./features/permission-management/permission-management').then(m => m.PermissionManagement) },
      { path: 'settings/external-user-sync', loadComponent: () => import('./features/settings/external-user-sync/external-user-sync').then(m => m.ExternalUserSync) },
    ]
  },
  { path: '**', redirectTo: 'login' }
];



